/* eslint-disable default-case */
import React, { useState, useEffect, ChangeEvent } from 'react';
import './index.css';
import './smooth.css';

interface QuantityPickerProps {
  value?: number;
  min?: number;
  max?: number;
  onChange?: (value: number) => void;
  smooth?: boolean;
  width?: string;
  disableInc?: boolean;
  disableDec?: boolean;
}

const QuantityPicker = ({
  value: propValue = 0,
  min,
  max,
  onChange,
  smooth = false,
  width = '10rem',
  disableInc = false,
  disableDec = false,
}: QuantityPickerProps): React.JSX.Element => {
  const [value, setValue] = useState<number>(propValue);

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const inputValue = Number(event.target.value);
    if (!isNaN(inputValue)) {
      if ((min === undefined || inputValue >= min) && (max === undefined || inputValue <= max)) {
        setValue(inputValue);
        onChange?.(inputValue);
      }
    }
  };

  const handleIncrement = () => {
    const newValue = value + 1;
    if (max === undefined || newValue <= max) {
      setValue(newValue);
      onChange?.(newValue);
    }
  };

  const handleDecrement = () => {
    const newValue = value - 1;
    if (min === undefined || newValue >= min) {
      setValue(newValue);
      onChange?.(newValue);
    }
  };

  useEffect(() => {
    const abortController = new AbortController();
    return () => {
      abortController.abort();
    };
  }, []);

  return smooth ? (
    <div style={{ width }} data-quantity="">
      <button onClick={handleDecrement} type="button" title="Down" className="sub">
        Down
      </button>
      <input
        style={{ width }}
        value={value}
        type="number"
        name="quantity"
        pattern="[0-9]+"
        onChange={handleInputChange}
      />
      <button type="button" title="Up" className="add" onClick={handleIncrement}>
        Up
      </button>
    </div>
  ) : (
    <span className="quantity-picker">
      <button
        className={`${disableDec ? 'mod-disable ' : ''}quantity-modifier modifier-left`}
        onClick={handleDecrement}
      >
        &ndash;
      </button>
      <input
        style={{ width: '4rem' }}
        className="quantity-display"
        type="text"
        value={value}
        onChange={handleInputChange}
      />
      <button
        className={`${disableInc ? 'mod-disable ' : ''}quantity-modifier modifier-right`}
        onClick={handleIncrement}
      >
        &#xff0b;
      </button>
    </span>
  );
};

export default QuantityPicker;
